import { HOME } from "./names.type";

export const HEADER = {
  CMS: "Menu Navigasi CMS",
  BERANDA: "Menu Beranda",
  MIDDLE: "Menu Navigasi Spektra",
  NMC: "Menu Navigasi NMC",
  UFI: "Menu Navigasi UFI",
  SETUP: "Setup CMS",
  SETTING: "Setting",
  OTHER: "Other"
};

export const defaultMenu = [
  {
    id: "1",
    url: HOME,
    category: "DEFAULT",
    menu_name: "Home",
    icon: "home"
  },
  {
    header: HEADER.BERANDA
  },
  {
    header: HEADER.MIDDLE
  },
  {
    header: HEADER.NMC
  },
  {
    header: HEADER.UFI
  },
  {
    header: HEADER.CMS
  },
  {
    header: HEADER.SETUP
  },
  {
    header: HEADER.SETTING
  },
  {
    header: HEADER.OTHER
  }
];
